// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--trxsm","title-wrapper":"_9e1425b4d3--title-wrapper--XOIdO","button-wrapper":"_9e1425b4d3--button-wrapper--Jjt_F"};